import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Spinner = () => (
  <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin" style={{ borderColor: '#D4A017', borderTopColor: 'transparent' }} />
  </div>
);

const AuthUnavailable = ({ message, retry }) => (
  <div data-testid="auth-unavailable" role="alert" className="min-h-screen bg-white flex flex-col items-center justify-center gap-5 p-6 text-center">
    <p data-testid="auth-unavailable-message" className="text-sm text-gray-700">{message}</p>
    <button data-testid="auth-retry-button" onClick={retry} className="px-6 py-3 bg-[#D4A017] text-[#0f172a] font-semibold rounded-md">Opnieuw proberen</button>
  </div>
);

export const PortalRoute = ({ children }) => {
  const { user, loading, authError, refreshUser } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner />;
  if (authError && !user) return <AuthUnavailable message={authError} retry={refreshUser} />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // Force password change voor approved partners die nog hun tijdelijke wachtwoord gebruiken
  if (user.must_change_password && location.pathname !== '/platform/wachtwoord-wijzigen') {
    return <Navigate to="/platform/wachtwoord-wijzigen" replace />;
  }
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, loading, authError, refreshUser } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner />;
  if (authError && !user) return <AuthUnavailable message={authError} retry={refreshUser} />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.must_change_password && location.pathname !== '/platform/wachtwoord-wijzigen') {
    return <Navigate to="/platform/wachtwoord-wijzigen" replace />;
  }
  // Niet-admins gaan naar /platform (niet het oude /portal)
  if (!['admin', 'manager', 'specialist'].includes(user.role)) {
    return <Navigate to="/platform" replace />;
  }
  return children;
};
